$(document).ready(function () {
    $('#change-password-form').submit(function (e) {
        e.preventDefault();
        let form = $(this);
        let url = form.attr('action');
        window.axios.post(url, form.serialize())
            .then(() => {
                let myModal = $('#change-password-modal');
                myModal.find('.is-invalid').removeClass('is-invalid');
                myModal.find('.invalid-feedback').remove();
                myModal.modal('hide');
                $('#passwordChangedToast').toast('show');
            })
            .catch((error) => {
                let myModal = $('#change-password-modal');
                myModal.find('.is-invalid').removeClass('is-invalid');
                myModal.find('.invalid-feedback').remove();
                if (error.response.data.hasOwnProperty('errors')) {
                    for (let name in error.response.data.errors) {
                        let input = myModal.find('input[name="' + name + '"]');
                        input.addClass('is-invalid');
                        input.parent().append('<div class="invalid-feedback">' + error.response.data.errors[name] + '</div>');
                    }
                } else {
                    let errorBox = $("#change-password-modal-error-box");
                    errorBox.text(error.response.data.message);
                    errorBox.show();
                }
            });
    });

    $('#change-personal-data-form').submit(function (e) {
        e.preventDefault();
        let form = $(this);
        let url = form.attr('action');

        window.axios.post(url, form.serialize())
            .then(() => {
                window.location.reload();
            })
            .catch((error) => {
                let errorBox = $("#change-personal-data-modal-error-box");
                errorBox.text(error.response.data.message);
                errorBox.show();
            });
    });
});
